<!--
    Badge
    徽章
-->
<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="徽章" name="徽章">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in badge"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="badgeFormActive">
              <TinplateBadge v-if="badge[0].status"/>
              <PlasticBadge v-if="badge[1].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import TinplateBadge from "./Badge/TinplateBadge.vue";
import PlasticBadge from "./Badge/PlasticBadge.vue"
export default {
  name: "Badge",
  methods: {},
  components: {
    TinplateBadge,
    PlasticBadge
  },
  data() {
    return {
      forcollapse: ['马口铁底徽章','塑料底徽章'],
      badge: [
        { id: "TinplateBadge", name: "马口铁底徽章", status: false },
        { id: "PlasticBadge", name: "塑料底徽章", status: false }
      ],
      badgeFormActive: []
    };
  }
};
</script>
<style scoped>
</style>